import { KIOSK_ROUTE, SURVEY_ROUTE, SURVEY_SUBMIT_ROUTE } from '../constants/routes';
import { createUrl } from './router_helper';

export const WORKTANGO_URL = 'https://worktango.com';
export const TERMS_OF_USE_URL = 'https://worktango.com/terms-of-use';
export const PRIVACY_POLICY_URL = 'https://worktango.com/privacy-policy';
export const PRIVACY_NOTICE_URL = 'https://worktango.com/privacy-notice';

export const createSurveyUriWithQueryParams = (queryParams) => (hashCode) => {
  console.warn('This function is deprecated. Replace it for useRouter#goTo');
  return createUrl(SURVEY_ROUTE, [hashCode], { queryParams });
};

export const createKioskUriWithQueryParams = (queryParams) => (companyId) => {
  console.warn('This function is deprecated. Replace it for useRouter#goTo');
  return createUrl(KIOSK_ROUTE, [companyId], { queryParams });
};

export const createSubmitUriWithQueryParams = (queryParams, hashCode) => () => {
  console.warn('This function is deprecated. Replace it for useRouter#goTo');
  return createUrl(SURVEY_SUBMIT_ROUTE, [hashCode], { queryParams });
};
